export default "__VITE_ASSET__BUH82F58__"